export default __webpack_public_path__ + "static/media/crops-logo-white.320f7d6b.svg";